import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const MicrosoftIconColor = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 21"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ display: "block" }}
    width="1em"
    height="1em"
    ref={ref}
    {...props}
  >
    <path fill="#f35325" d="M0 0h10v10H0z" />
    <path fill="#81bc06" d="M11 0h10v10H11z" />
    <path fill="#05a6f0" d="M0 11h10v10H0z" />
    <path fill="#ffba08" d="M11 11h10v10H11z" />
  </svg>
);
const ForwardRef = forwardRef(MicrosoftIconColor);

export { ForwardRef as MicrosoftIconColor };
